import moment from 'moment'
export default {
  methods: {
    dateFormat(date, formatString) {
      return moment(date).format(formatString)
    },

    formatDateInclusive(date) {
      // return previous date for date time with 00:00:00 time to make it inclusive. 
      // E.g., 2024-06-10 00:00:00 should be displayed as 2024-06-09
      // Subtracting 1 hour and 1 second to cover possible timezone differences
      let result = moment.parseZone(date).subtract(1, 'h').subtract(1, 's')
      return result.format('MMM DD, YYYY')
    },

    millisecondsToDuration(milliseconds) {
      return moment.utc(milliseconds).format('HH:mm:ss')
    },

    secondsToDuration(seconds) {
      if (seconds === '' || seconds == null) {
        return ''
      }
      
      return moment.utc(seconds * 1000).format('HH:mm:ss')
    }
  }
}
